import { render, staticRenderFns } from "./AudienceSummaryItem.vue?vue&type=template&id=9a174c44&scoped=true&"
import script from "./AudienceSummaryItem.vue?vue&type=script&lang=js&"
export * from "./AudienceSummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./AudienceSummaryItem.vue?vue&type=style&index=0&id=9a174c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a174c44",
  null
  
)

export default component.exports